import { FormikProps } from "formik"
import { FormikCheckBox } from "./CustomFormikFormFields"
import { MSG_ACKNOWLEDGE_FEE_1, MSG_ACKNOWLEDGE_FEE_2  } from "../../constants"

export const AcknowledgeFeeCheck = ({formik} : {formik: FormikProps<any>}) => {
  return (
  <div className='fv-row '>
    <div className='form-check form-check-sm form-check-custom form-check-solid mt-2 d-flex flex-row align-items-start gap-2'>
      <input
        {...formik.getFieldProps('acknowledgeFee')}
        name='acknowledgeFee'
        className='form-check-input'
        type='checkbox'
        disabled={formik.isSubmitting}
      />
      <div>
      <label className='form-check-label'>{`${MSG_ACKNOWLEDGE_FEE_1} ${MSG_ACKNOWLEDGE_FEE_2}`}</label>
      {formik.errors.acknowledgeFee && (
      <div className='ps-2 fv-plugins-message-container'>
        <div className='fv-help-block'>
          {`${formik.errors.acknowledgeFee}`}
        </div>
      </div>
      )}
      </div>
    </div>
  </div>
  )
}

type Props = { 
  dlmtype: string,
}

export const FormikAcknowledgeFeeCheck = ({dlmtype} : Props) => {
  return(
  <div className="row my-2 px-3">      
    <div className="rounded border border-danger border-opacity-75 px-4 pt-2 pb-4">      
      <FormikCheckBox size="12" name="acknowledgeFee" label={`${MSG_ACKNOWLEDGE_FEE_1} per ${dlmtype}${MSG_ACKNOWLEDGE_FEE_2}`} required /> 
    </div>
  </div>
  )
}